import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import QAEmailToolbar from "./QAEmailToolbar";
import ErrorAlert from "../../components/ErrorAlert";
import NonIdealState from "../../components/NonIdealState";

import styles from "./QAEmailPage.module.css";
import { fetchEmail, selectEditorModule, fetchEmailQA, updateEditorTranslationVariation } from "../../actions";

export class QAEmailPage extends Component {
  constructor(props) {
    super(props);
    this.renderTest = this.renderTest.bind(this);
  }

  componentWillMount() {
    const { id } = this.props.match.params;
    const { accountId } = this.props.match.params;

    this.props.fetchEmailQA(accountId, id);
    this.props.fetchEmail(accountId, id);
  }

  componentDidUpdate(prevProps) {
    // default variation when email loads
    if (!prevProps.email.id && this.props.email.id && !this.props.email.var) {
      if (this.props.email.translations) {
        this.props.updateEditorTranslationVariation(
          Object.keys(this.props.email.translations)[0]
        );
      } else {
        // no translations --> use "master"
        this.props.updateEditorTranslationVariation("master");
      }
    }
  }

  renderTest(test) {
    const logo =
      test.level === "pending" ? (
        <div className={styles.status}>🏳</div>
      ) : test.level === "warning" ? (
        <div className={styles.status}>⚠️</div>
      ) : test.level === "error" ? (
        <div className={styles.status}>❌</div>
      ) : (
        <div className={styles.status}>✅</div>
      );

    const message = test.message ? <p>{test.message}</p> : undefined;

    const imageUrl = test.image
      ? `${process.env.REACT_APP_API_ENDPOINT}${test.image}`
      : null;

    return (
      <div className={styles.test}>
        {logo}
        <strong>{test.name}</strong>
        {message}
        {test.line && (
          <div>
            <strong>Line:</strong> {test.line}
          </div>
        )}
        {test.column && (
          <div>
            <strong>Column:</strong> {test.column}
          </div>
        )}
        {imageUrl && (
          <div>
            <img src={imageUrl} style={{ maxWidth: 100, maxHeight: 100, objectFit: 'contain' }} alt="Issue preview" />
          </div>
        )}
      </div>
    );
  }

  render() {
    const { accountId } = this.props.match.params;
    const { email, tests, displayWidth } = this.props;

    if (email.failed) {
      return (
        <ErrorAlert title="404">
          <Link to={`/clients/${accountId}/campaigns`}>Return to list</Link>
        </ErrorAlert>
      );
    }

    if (!email.id) {
      return <div />;
    }

    const url = `${process.env.REACT_APP_API_ENDPOINT
      }/api/clients/${accountId}/emails/${email.id}/html?var=${email.var ? email.var : ""
      }`;

    const currentVariation = email.var || "master";
    const filteredTests = tests.filter(
      (test) => test.variation === currentVariation
    );

    return (
      <div>
        <QAEmailToolbar accountId={accountId} />
        <div className={styles.left}>
          {filteredTests.length === 0 && (
            <NonIdealState title="All Tests Passing" visual="check" />
          )}
          {filteredTests.map(this.renderTest)}
        </div>
        <div className={styles.right}>
          <div style={{ height: "100%", width: displayWidth }}>
            <iframe frameBorder="0" src={url}></iframe>
          </div>
        </div>
      </div>
    );
  }
}

QAEmailPage.propTypes = {
  email: PropTypes.object.isRequired,
  tests: PropTypes.array.isRequired,
  html: PropTypes.string,
  params: PropTypes.object,
  fetchEmail: PropTypes.func.isRequired,
  fetchEmailQA: PropTypes.func.isRequired,
  updateEditorTranslationVariation: PropTypes.func.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { email, displayWidth } = state.editor;
  const { html, tests } = state.qa;
  return {
    email,
    html,
    tests,
    displayWidth,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  fetchEmailQA,
  fetchEmail,
  selectEditorModule,
  updateEditorTranslationVariation,
})(QAEmailPage);
